function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  fillRule: "nonzero",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.198 26.641l-6.875-6.875 6.768-6.769a.552.552 0 00.038-.836l-1.418-1.418a.68.68 0 00-.946-.072l-6.769 6.768-6.763-6.764a.68.68 0 00-.944.065l-1.418 1.418a.559.559 0 00.037.842l6.766 6.766-6.873 6.873a.851.851 0 00-.055 1.074l1.417 1.417c.256.256.71.091.965-.165l6.873-6.873 6.875 6.876c.256.255.71.416.965.16l1.418-1.418a.841.841 0 00-.06-1.069z",
  fill: "#FFF"
}));

function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRemove;